import {Observable} from 'rxjs';
import {FilterFieldType} from '@core/interfaces/system/system-common';

export interface SubgroupChangeOrderDto {
    newOrderByField: string;
    newOrderByDirection: OrderByDirection;
}
export enum OrderByDirection {
    ASC = 'ASC',
    DESC = 'DESC',
}

export interface SortByOptionDto {
    value: string;
    label: string;
    orderBy: SortByOptionSortDto[];
}

// Display/UI configuration
export interface SortByOptionSortDto {
    key: OrderByDirection;
    label: string;
}

export abstract class GroupInspectionValuesService {
    abstract deleteSubGroupInspection(subGroupId: number): Observable<void>;
    abstract changeSubgroupContentOrder(subGroupId: number, reqBody: SubgroupChangeOrderDto): Observable<void>;
}
